<script context="module">
  let counter = 0; // for element IDs
</script>

<script>
  import { LayerCake, Svg } from "layercake";

  import Area from "./_components/Area.svelte";
  import Line from "./_components/Line.svelte";

  /** @type {[Date, Date]} Time interval to display in the x-axis. */
  export let xDomain;

  /** @type {string} Color of the metric line. */
  export let stroke;

  /** @type {string} Color of the filled metric area. */
  export let fill;

  /**
   * @type {Array} Data points to display in the chart.
   *
   * Each data point should be an object in the following format:
   * `{ date: Date, value: number }`.
   */
  export let data;

  const xKey = "date";
  const yKey = "value";

  const idSuffix = "Sparkline-" + counter++;
</script>

<div class="w-full h-full flex flex-col">
  <div class="flex-1">
    <LayerCake
      x={xKey}
      y={yKey}
      {xDomain}
      yDomain={[0, null]}
      {data}
      let:width
      let:height
    >
      <Svg>
        <defs>
          <clipPath id="clip-{idSuffix}">
            <!-- Prevent the line from rendering outside the main chart area. -->
            <rect x={-1} y={-1} width={width + 2} height={height + 2} />
          </clipPath>
        </defs>

        <g clip-path="url(#clip-{idSuffix})">
          <Line {stroke} />
          <Area {fill} />
        </g>
      </Svg>
    </LayerCake>
  </div>
</div>
